export default __webpack_public_path__ + "static/media/forestly-expl-01_EN.032c469f.png";